import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { Dialog, Card, CardBody, Typography } from "@material-tailwind/react";
import "./style.css";
import { MdDelete } from "react-icons/md";
import ListModal from "pages/Store/components/ListModal";
import { useDispatch, useSelector } from "react-redux";
import Modal from "./components/Modal";
import { useNavigate } from "react-router";
import { isValidEmail } from "constants";
import { IoClose } from "react-icons/io5";
import avatar from "assets/altImage.png";
import {
  addFriend,
  getAllFriends,
  deleteFriend,
  changeFriendRequestStatus,
  getPendingFriendRequestsCount,
} from "store/services/Friends/friends";
import { showToast } from "utils/showToast";
import { updatePendingFriendRequestCount } from "store/actions/Profile/profile";
const Friends = ({ isOpen, handleClose }) => {
  const { user } = useSelector((store) => store.userReducer);
  const dispatch = useDispatch();
  const [getFriends, setGetFriends] = useState([]);
  const [friends, setFriends] = useState([]);
  const modalData = {
    title: "Members",
  };
  const { selectedStore } = useSelector((store) => store.selectedStore);

  const { profile } = useSelector((store) => store.userProfile);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleMessageModalToggle = () => {
    setIsMessageModalOpen(!isMessageModalOpen);
  };

  const onchangeHandler = (e) => {
    setEmail(e.target.value);
    setError("");
  };
  const closeHandler = (e) => {
    handleModalToggle();
  };
  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      if (!email) {
        setError("Please enter email ");
        return;
      } else if (!isValidEmail(email)) {
        setError("Please enter email in correct format");
      }
      if (
        profile.first_name === "" ||
        profile.first_name === null ||
        profile.last_name === "" ||
        profile.last_name === null ||
        profile.location === "" ||
        profile.location === null ||
        profile.email === "" ||
        profile.last_name === null ||
        profile.phone_number === "" ||
        profile.last_name === null
      ) {
        setModalContent({
          title: "Note",
          description: "Please complete your profile",
          purpleButton: "PROFILE",
          redButton: "CANCEL",
        });
        setIsModalOpen(false);
        setIsMessageModalOpen(true);
      } else {
        const newMember = await addFriend(
          user.accessToken,
          user.data.id,
          selectedStore.id,
          { email }
        );
        if (newMember.success) {
          setEmail("");
          setError("");
          setIsModalOpen(false);
          setModalContent({
            title: "Member Added",
            description: newMember.data,
            redButton: "OKAY",
          });
          setIsMessageModalOpen(true);
        } else {
          setEmail("");
          setError("");

          setIsModalOpen(false);
          setModalContent({
            title: "Member Not Added",
            description: newMember.message,
            redButton: "CLOSE",
          });
          setIsMessageModalOpen(true);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteFriend = async (friend_id) => {
    try {
      const removeFriend = await deleteFriend(
        user.accessToken,
        user.data.id,
        friend_id
      );
      if (removeFriend.success) {
        const remFriends = friends.filter((friend) => friend.id !== friend_id);
        setFriends(remFriends);
        setModalContent({
          title: "Member Deleted",
          description: removeFriend.data,
          redButton: "OKAY",
        });
        setIsMessageModalOpen(true);
      } else {
        showToast(removeFriend.message, "error", true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleChangeFriendRequest = async (
    friend_id,
    status,
    requestedByFriend,
    message
  ) => {
    try {
      if (
        profile.first_name === "" ||
        profile.last_name === "" ||
        profile.location === "" ||
        profile.email === "" ||
        profile.phone_number === ""
      ) {
        setModalContent({
          title: "Note",
          description: "Please complete your profile",
          purpleButton: "PROFILE",
          redButton: "CANCEL",
        });
        setIsMessageModalOpen(true);
      } else {
        const updateFriendRequestStatus = await changeFriendRequestStatus(
          user.accessToken,
          user.data.id,
          selectedStore.id,
          friend_id,
          { status, requestedByFriend }
        );
        if (updateFriendRequestStatus.success) {
          const updatedFriends = friends.map((friend) => {
            if (friend.id === friend_id) {
              return { ...friend, status: status };
            }
            return friend;
          });
          setFriends(updatedFriends);
          setModalContent({
            title: "Member Added",
            description: message,
            redButton: "OKAY",
          });
          const countFriendRequests = await getPendingFriendRequestsCount(
            user.accessToken,
            user.data.id
          );
          if (countFriendRequests.success) {
            dispatch(
              updatePendingFriendRequestCount(
                countFriendRequests.data.totalCount
              )
            );
          }
          setIsMessageModalOpen(true);
        } else {
          showToast(updateFriendRequestStatus.message, "error", true);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleMessageModal = (profile) => {
    if (profile === "PROFILE") {
      navigate(`/users/${user.data.id}/updateProfile`);
      setIsMessageModalOpen(false);
      handleClose();
    }
  };
  const memberInfo = {
    title: "Add Member",
    description: "Enter a valid Mavencery email",
    label: "Email",
    redButton: "CANCEL",
    purpleButton: "ADD",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user) {
          const result = await getAllFriends(user.accessToken, user.data.id);
          if (result) {
            const { userFriends, friends } = result.data;

            setGetFriends(userFriends);
            setFriends(friends);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (isOpen) {
      fetchData();
    }
  }, [user, isOpen]);
  return (
    <Dialog
      size="xs"
      open={isOpen}
      handler={handleClose}
      className="bg-transparent shadow-none"
    >
      <div className={`relative border-none  `}>
        <Card className={`modal-card mx-auto mt-8 overflow-auto`}>
          <CardBody className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <Typography variant="h4" color="blue-gray">
                {modalData.title}
              </Typography>
              <div className="flex items-center justify-center gap-4">
                <div
                  onClick={handleModalToggle}
                  className="relative flex items-center justify-center w-6 h-6 rounded-full bg-theme-color"
                >
                  <FaPlus size={15} className="text-white" />
                  <span className="tooltip">Add Member</span>
                </div>
                <div
                  className="flex items-center justify-center w-6 h-6 bg-red-700 rounded-full"
                  onClick={handleClose}
                >
                  <IoClose size={20} className="font-bold text-white" />
                </div>
              </div>
            </div>
            {friends && friends.length > 0 ? (
              friends.map((friend, id) => {
                let member;
                if (friend.status === "Pending") {
                  member = getFriends?.find(
                    (userFriend) =>
                      userFriend.id === friend.request_initiated_by
                  );
                } else if (
                  friend.status === "Approved" &&
                  friend.request_initiated_by === user.data.id
                ) {
                  member = getFriends?.find(
                    (userFriend) => userFriend.id === friend.request_to
                  );
                } else if (
                  friend.request_initiated_by !== user.data.id &&
                  friend.status === "Approved"
                ) {
                  member = getFriends?.find(
                    (userFriend) =>
                      userFriend.id === friend.request_initiated_by
                  );
                }
                return (
                  <div
                    className={`flex w-full items-center justify-between lg:gap-4 md:gap-4 gap-6 h-20 px-2 py-2 mx-1 lg:text-sm md:text-sm text-xs text-gray-900 border rounded-md shadow-xl ${
                      friend?.status === "Pending" && member === undefined
                        ? "hidden"
                        : ""
                    } ${
                      friend?.status && friend.status === "Reject"
                        ? "hidden"
                        : ""
                    }`}
                    key={id}
                  >
                    <div className="flex items-center w-5/6 gap-2 justify-right">
                      <div className="w-10 lg:ml-2 sm:ml-1">
                        <img
                          className="object-contain w-10 h-10 rounded-full "
                          src={member?.photo_url ? member.photo_url : avatar}
                          alt="profileImg"
                        ></img>
                      </div>
                      <div className=" lg:w-56 w-52">
                        <div className="text-sm font-bold sm:text-xm">
                          {member?.first_name} {member?.last_name}
                        </div>
                        <div className="w-full text-xs break-words whitespace-normal">
                          {member?.email}
                        </div>
                        <div
                          className={`flex items-center justify-between w-3/4  gap-6 font-bold ${
                            friend.status === "Pending" ? "" : "hidden"
                          }`}
                        >
                          <div
                            onClick={() =>
                              handleChangeFriendRequest(
                                friend.id,
                                "Approved",
                                friend.request_initiated_by,
                                "Friend request accepted!"
                              )
                            }
                            className="w-16 px-2 py-1 text-xs text-center text-white border rounded-md cursor-pointer bg-theme-color"
                          >
                            Accept
                          </div>
                          <div
                            onClick={() =>
                              handleChangeFriendRequest(
                                friend.id,
                                "Reject",
                                friend.request_initiated_by,
                                "Friend request rejected!"
                              )
                            }
                            className="w-16 px-2 py-1 text-xs text-center text-white bg-red-800 border rounded-md cursor-pointer"
                          >
                            Reject
                          </div>
                        </div>
                      </div>
                    </div>
                    {friend.status !== "Pending" && (
                      <div
                        className={`text-gray-800 mr-3 w-1/6   hover:text-red-600 ${
                          friend.status === "Pending" ? "hidden" : ""
                        }`}
                      >
                        <MdDelete
                          onClick={() => handleDeleteFriend(friend.id)}
                          size={20}
                        />
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <Typography
                className="mb-3 font-normal"
                variant="paragraph"
                color="gray"
              >
                No Members Added
              </Typography>
            )}
          </CardBody>
        </Card>
        {isModalOpen && (
          <ListModal
            isOpen={isOpen}
            handleClose={closeHandler}
            modalData={memberInfo}
            listName={email}
            error={error}
            onChangeHandler={onchangeHandler}
            handleAdd={handleAdd}
          />
        )}

        {isMessageModalOpen && (
          <Modal
            modalData={modalContent}
            handleModalToggle={handleMessageModalToggle}
            isOpen={isMessageModalOpen}
            submitHandler={handleMessageModal}
          />
        )}
      </div>
    </Dialog>
  );
};
export default Friends;
